import { getColor } from "./getColor";
import { InvoiceIconType } from "./invoice.icon";

const MarginIcon = ({ active }: InvoiceIconType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.8746 0.833984H3.12467C1.86082 0.833984 0.833008 1.8618 0.833008 3.12565V16.8757C0.833008 18.1395 1.86082 19.1673 3.12467 19.1673H16.8746C18.1385 19.1673 19.1663 18.1395 19.1663 16.8757V3.12565C19.1663 1.8618 18.1385 0.833984 16.8746 0.833984ZM17.6385 16.8757C17.6385 17.2969 17.2959 17.6395 16.8746 17.6395H3.12467C2.70339 17.6395 2.36078 17.2969 2.36078 16.8757V3.12565C2.36078 2.70437 2.70339 2.36176 3.12467 2.36176H16.8746C17.2959 2.36176 17.6385 2.70437 17.6385 3.12565V16.8757Z"
        fill={getColor(active)}
      />
      <path
        d="M10 6.25C10.345 6.25 10.625 5.97 10.625 5.625V3.125C10.625 2.78 10.345 2.5 10 2.5C9.655 2.5 9.375 2.78 9.375 3.125V5.625C9.375 5.97 9.655 6.25 10 6.25Z"
        fill={getColor(active)}
      />
      <path
        d="M3.125 10.625H5.62499C5.96999 10.625 6.24999 10.345 6.24999 10C6.24999 9.655 5.96999 9.375 5.62499 9.375H3.125C2.78 9.375 2.5 9.655 2.5 10C2.5 10.345 2.78 10.625 3.125 10.625Z"
        fill={getColor(active)}
      />
      <path
        d="M10 17.5C10.345 17.5 10.625 17.22 10.625 16.875V14.375C10.625 14.03 10.345 13.75 10 13.75C9.655 13.75 9.375 14.03 9.375 14.375V16.875C9.375 17.22 9.655 17.5 10 17.5Z"
        fill={getColor(active)}
      />
      <path
        d="M16.875 9.375H14.375C14.03 9.375 13.75 9.655 13.75 10C13.75 10.345 14.03 10.625 14.375 10.625H16.875C17.22 10.625 17.5 10.345 17.5 10C17.5 9.655 17.22 9.375 16.875 9.375Z"
        fill={getColor(active)}
      />
    </svg>
  );
};

export default MarginIcon;
